import React from 'react';
import PaybackPeriodCalculator from './PaybackPeriod/index';

function PaybackPeriod() {
  return <PaybackPeriodCalculator />;
}

export default PaybackPeriod;